import _defineProperty from '@babel/runtime/helpers/esm/defineProperty';
import { isFunction } from '@elliemae/ds-utilities/utils';
import strategiesOperators from './strategiesOperators.js';
import 'comparejs';

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var getRuleStrategyOperator = function getRuleStrategyOperator(rule) {
  return rule.strategy || strategiesOperators(rule.operator);
};

var executeFilterStrategy = function executeFilterStrategy(rule, row) {
  var value = rule.value,
      field = rule.field,
      transform = rule.transform,
      transformRowValue = rule.transformRowValue;
  if (field === 'all') return Object.values(row).some(function (colValue) {
    return strategiesOperators('contains')(colValue, value);
  });
  var rowValue = row[field];
  var transformedValue = isFunction(transform) ? transform(value) : value;
  var transformedRowValue = isFunction(transformRowValue) ? transformRowValue(rowValue) : rowValue;
  var filterStrategy = getRuleStrategyOperator(rule);
  return filterStrategy(transformedRowValue, transformedValue);
};

var filterByRules = function filterByRules(rules) {
  var condition = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'AND';
  return function (row) {
    return condition === 'AND' ? rules.reduce(function (isFiltered, rule) {
      return rule.rules && rule.rules.length ? isFiltered && filterByRules(rule.rules, rule.condition)(row) : isFiltered && executeFilterStrategy(rule, row);
    }, true) : rules.some(function (rule) {
      return rule.rules && rule.rules.length ? filterByRules(rule.rules, rule.condition)(row) : executeFilterStrategy(rule, row);
    });
  };
};

function filterRowsByQueryGroup(rows, query, composedRows) {
  if (query && query.rules && query.rules.length === 0) return rows;
  var newRows = [];
  var parentMap = {};
  composedRows.forEach(function (parentRow) {
    if (parentRow.isGroup) {
      newRows.push(_objectSpread(_objectSpread({}, parentRow), {}, {
        _filtered: true
      }));
    } else if (!parentRow.isGroup && filterByRules(query.rules, query.condition)(parentRow.data)) {
      newRows.push(_objectSpread(_objectSpread({}, parentRow), {}, {
        _filtered: true
      }));
      parentMap[parentRow.parentNode.id] = true;
    }
  });
  return newRows.filter(function (r) {
    if (r.isGroup && !parentMap[r.id]) return false;
    return true;
  });
}
function filterRowsByQuery(rows, query) {
  return rows.filter(filterByRules(query.rules, query.condition));
}

export default filterRowsByQuery;
export { filterRowsByQueryGroup };
//# sourceMappingURL=filterRowsByQuery.js.map
